import React, { createContext, useContext, useState } from "react";

const adminContext = createContext();

export const AdminCrudContextProvider = ({ children }) => {

    const [pageValue, setPageValue] = useState(1);
    const [searchValue, setSearchValue] = useState("");

    const [countryDetail, setCountryDetail] = useState({
        country_name: "",
        page: 1
    })

    const value = {
        pageValue,
        searchValue,
        setPageValue,
        setSearchValue,
        setCountryDetail,
        countryDetail
    };

    return (
        <adminContext.Provider value={value}>
            {children}
        </adminContext.Provider>
    );
};

export function useContextCrud() {
    return useContext(adminContext);
}